<template>
  <review-member-settings-panel
    :researcher-search-input.sync="researcherSearchInput"
    :researcher-search-results="searchResearchers"
    :lead-reviewer="review.leadReviewer"
    :reviewers="review.reviewers"
    :viewers="review.viewers"
    :invites="review.invites"
    :loading="$apollo.queries.searchResearchers.loading"
    :user-is-lead-or-super-user="userIsLeadOrSuperUser"
    @invite-member="inviteMember"
    @update-member="onSaveMember"
    @remove-member="onRemoveMember"
    @revoke-invite="revokeInvite"
  />
</template>

<script>
import ReviewMemberSettingsPanel from './ReviewMemberSettingsPanel';
import {
  Review,
  Researcher,
  ReviewMember,
  ReviewMemberInvite,
} from '@/models';
import { SearchResearchers } from '@/graphql';
import { mapActions } from 'vuex';

export default {
  name: 'ReviewMemberSettingsController',
  components: {
    ReviewMemberSettingsPanel,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
    currentResearcher: {
      type: Researcher,
      required: true,
    },
  },
  data: () => ({
    searchResearchers: [],
    researcherSearchInput: null,
  }),
  apollo: {
    searchResearchers: {
      query: SearchResearchers,
      variables() {
        return {
          searchInput: {
            name: this.researcherSearchInput,
            email: this.researcherSearchInput,
          },
        };
      },
      update: (data) =>
        data.searchResearchers.map(
          (researcher) => new Researcher(researcher)
        ),
      skip() {
        return (
          !this.researcherSearchInput || !this.userIsLeadOrSuperUser
        );
      },
    },
  },
  computed: {
    userIsLead() {
      return (
        this.currentResearcher.id ===
        this.review.leadReviewer.researcher.id
      );
    },
    userIsLeadOrSuperUser() {
      return this.userIsLead || this.currentResearcher.isSuperAdmin;
    },
  },
  methods: {
    ...mapActions({
      sendInvite: 'reviewMemberInvite/createReviewMemberInvite',
      deleteMemberInvite:
        'reviewMemberInvite/deleteReviewMemberInvite',
      saveMember: 'reviewMember/saveReviewMember',
      deleteMember: 'reviewMember/deleteReviewMember',
    }),
    onSaveMember(reviewMember) {
      this.saveMember(this.injectReview(reviewMember));
    },
    inviteMember({ emailAddress, memberRole }) {
      const reviewMemberInvite = {
        review: this.review.id,
        emailAddress,
        memberRole,
      };
      this.sendInvite(reviewMemberInvite);
    },
    onRemoveMember(reviewMember) {
      this.deleteMember(this.injectReview(reviewMember));
    },
    revokeInvite(invite) {
      this.deleteMemberInvite(this.injectReviewToInvite(invite));
    },
    injectReview(reviewMember) {
      // Inject review into review member records when saving (for cache updates).
      return new ReviewMember({
        ...reviewMember,
        review: this.review,
      });
    },
    injectReviewToInvite(reviewMemberInvite) {
      // Inject review into review member invite records when saving (for cache updates).
      return new ReviewMemberInvite({
        ...reviewMemberInvite,
        review: this.review,
      });
    },
  },
};
</script>
